import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./referralHeader.css";
import ListReferrals from "../Referrals/listReferral";
import SignupListReferrals from "../Referrals/signupReferral";
import { Skeleton } from "antd";

const STORAGE_KEY = "referral_header_tab";

const ReferralHeader = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "signup_referrals"
  );

  const [loading, setLoading] = useState(false);

  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "signup_referrals" ? "clicked" : ""}
              onClick={() => handleTableSelection("signup_referrals")}
            >
              Sign-Up Referral
            </h4>
            <h4
              className={selectedTable === "booking_referrals" ? "clicked" : ""}
              onClick={() => handleTableSelection("booking_referrals")}
            >
              Booking Referral
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "signup_referrals" ? "block" : "none" }}>
            <SignupListReferrals />
          </div>
          <div style={{ display: selectedTable === "booking_referrals" ? "block" : "none" }}>
            <ListReferrals />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ReferralHeader;
